import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize' //or titlecase or camel case
})

export class CapitalizePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return value && value.split(' ').map(word => {
      return word.length > 2 ? word[0].toUpperCase() + word.substr(1) : word;
    }).join(' ');
  }

  // Output some string - Some String
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/capitalize.pipe.ts